import { render, staticRenderFns } from "./PartnerOwnerEditForm.vue?vue&type=template&id=ba13e01a"
import script from "./PartnerOwnerEditForm.vue?vue&type=script&lang=js"
export * from "./PartnerOwnerEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports